import React, { useState } from 'react'

//MUI
import { AppBar, Box, Button, IconButton, Toolbar } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu';

//Router dom
import { Link } from 'react-router-dom';

//Components
import Sidebar from './Sidebar';

//img
import header_logo from '../../assets/images/logo_1_nb.png'

const Header = () => {
    const [open, setOpen] = useState(false)

    const handleOpen = () => {
        setOpen(true)
    }

    return (
        <>
            <AppBar position="sticky" sx={{ backgroundColor: '#fff' }}>
                <Toolbar>
                    <IconButton
                        onClick={handleOpen}
                        size="large"
                        edge="start"
                        aria-label="menu"
                        sx={{ mr: 2, display: { xs: 'flex', sm: 'flex', md: 'none', lg: 'none', xl: 'none', xxl: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Box sx={{ flexGrow: 1, alignItems: 'center', justifyContent: 'flex-end', display: { xxl: 'block', xl: 'block', lg: 'block', md: 'block', sm: 'flex', xs: 'flex', } }}>
                        <Link to='/'>
                            <img src={header_logo} alt='logo_F+H' width='75' />
                        </Link>
                    </Box>
                    <Box gap='12px' sx={{ display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex', xl: 'flex', xxl: 'flex' } }}>
                        <Button LinkComponent={Link} to='/' sx={{ color: '#000', textTransform: 'none', fontSize: '16px' }}>Inicio</Button>
                        <Button LinkComponent={Link} to='/nosotros' sx={{ color: '#000', textTransform: 'none', fontSize: '16px' }}>Nosotros</Button>
                        <Button LinkComponent={Link} to='/servicios' sx={{ color: '#000', textTransform: 'none', fontSize: '16px' }}>Servicios</Button>
                        {/* <Button LinkComponent={Link} to='/certificaciones' sx={{ color: '#000', textTransform: 'none', fontSize: '16px' }}>Certificaciones</Button> */}
                        <Button LinkComponent={Link} to='/contacto' sx={{ color: '#000', textTransform: 'none', fontSize: '16px' }}>Contacto</Button>
                    </Box>
                </Toolbar>
            </AppBar >

            <Sidebar open={open} setOpen={setOpen} />
        </>
    )
}

export default Header